module.exports = __webpack_public_path__ + "static/media/CompanyRightBackgroundSpots.49543058.png";